import { render, staticRenderFns } from "./RegisterEmployeeDoc.vue?vue&type=template&id=499c0868&"
import script from "./RegisterEmployeeDoc.vue?vue&type=script&lang=js&"
export * from "./RegisterEmployeeDoc.vue?vue&type=script&lang=js&"
import style0 from "./RegisterEmployeeDoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports